import React from "react";

const MapEmbed = () => {
  return (
    <div className="group relative block overflow-hidden rounded-lg ">
      <div className="border-2 border-green-600 bg-black rounded-xl shadow-lg lg:h-96 h-72 w-full">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d61403.913360044964!2d-48.10378137082109!3d-15.870015942874218!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x935a2d800e6d8f57%3A0x8aded7a5ca63e551!2sDominus%20tecnologia%20e%20acess%C3%B3rios!5e0!3m2!1spt-BR!2sbr!4v1746281499392!5m2!1spt-BR!2sbr"
          width="400"
          height="auto"
          allowFullScreen
          loading="lazy"
          className="h-full w-full object-contain object-center rounded-lg p-1 transition-transform duration-500 ease-in-out transform hover:scale-105"
          referrerPolicy="no-referrer-when-downgrade"
          title="Mapa da Dominus Tecnologia e Acessórios"
        />
      </div>

      <a
        href="https://www.google.com/maps/place/Dominus+tecnologia+e+acess%C3%B3rios/@-15.8700159,-48.1037814,17z/data=!3m1!4b1!4m6!3m5!1s0x935a2d800e6d8f57:0x8aded7a5ca63e551!8m2!3d-15.8700159!4d-48.1037814!16s%2Fg%2F11g6r7p6_s?hl=pt-BR"
        target="_blank"
        rel="noopener noreferrer"
        className="mt-2 inline-block text-blue-600 hover:underline"
      >
        Abrir no Google Maps
      </a>
    </div>
  );
};

export default MapEmbed;
